import gql from "graphql-tag";
import { ADDRESS_FOR_CHECKOUT_FRAGMENT } from "@components/pages/CheckoutPage/queries";

export const USER_FOR_CONTACT_FRAGMENT = gql`
  ${ADDRESS_FOR_CHECKOUT_FRAGMENT}
  fragment userForContact on User {
    id
    firstName
    lastName
    mobileNumber
    mobileVerified
    addresses {
    ...addressForCheckout
    }
  }
`;

export const ME_FOR_CONTACT = gql`
  ${USER_FOR_CONTACT_FRAGMENT}
  query meForContact {
    me {
    ...userForContact
    }
  }
`;

export const CUSTOMER_UPDATE = gql`
  ${USER_FOR_CONTACT_FRAGMENT}
  mutation customerUpdate($input: CustomerUpdateInput!) {
    customerUpdate(input: $input) {
      errors {
        field
        message
      }
      user {
      ...userForContact
      }
    }
  }
`;
